import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=46f6fe90&scoped=true&"
import script from "./TasksList.vue?vue&type=script&lang=js&"
export * from "./TasksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6fe90",
  null
  
)

export default component.exports